<template>
  <el-drawer
    title="版本记录"
    :visible.sync="showDrawer"
    :size="direction==='ltr' ? '30%' : 400"
    :modal="direction==='ltr'"
    :append-to-body="direction==='ltr'"
    :direction="direction"
  >
    <div class="data-version-container">
      <div class="top-content">
        <div class="title-info">{{ dataVersionInfo.resourceName }}</div>
        <div class="flex-align-center version-info">
          <span>适配软件：</span>
          <software-display :software-arr="versionFileInfo.softwareList" :software-version-name="versionFileInfo.softwareVersionName || versionFileInfo.softwareVersion" />
        </div>
      </div>

      <data-version-info
        v-if="dataVersionInfo.dataVersions && dataVersionInfo.dataVersions.length"
        :current-submodule="currentSubmodule"
        :resource-type="resourceType"
        :space-id="currentResource.spaceId"
        :public-id="currentResource.spaceResourceId"
        :version-id="currentResource.versionId"
        @version-changed="versionChanged"
        @toPlace="$emit('toPlace')"
        @toLoad="$emit('toLoad')"/>
    </div>
  </el-drawer>
</template>

<script>
import { mapGetters } from 'vuex'
import DataVersionInfo from '@/views/resource/components/DataVersionInfo.vue'
import SoftwareDisplay from '@/components/business/resource/SoftwareDisplay.vue'
export default {
  name: 'DataVersionRecord',
  components: { DataVersionInfo, SoftwareDisplay },
  props: {
    currentSubmodule: {
      type: String,
    },
    resourceType: {
      type: String,
      default: 'COMPONENT',
    },
    direction: {
      type: String,
      default: 'rtl'
    },
  },
  data() {
    return {
      showDrawer: false,
    }
  },
  computed: {
    ...mapGetters({
      currentResource: 'resourceDetail/currentResource',
      dataVersionInfo: 'resourceDetail/dataVersionInfo',
      versionFileInfo: 'resourceDetail/versionFileInfo',
    })
  },
  methods: {
    openDrawer() {
      this.showDrawer = true
    },
    versionChanged(item) {
      this.$emit('version-changed', item)
    }
  },
}
</script>

<style lang="less" scoped>
.el-drawer__title {
  color: @text-tag-gery;
}
.data-version-container{
  padding: 20px 0;
}
.top-content{
  padding: 0 16px;
}
.title-info{
  margin-bottom: 10px;
  font-weight: bold;
  font-size: 16px;
}
.version-info{
  margin-bottom: 20px;
  color: rgba(73, 95, 112, 0.6);
}
</style>
